
    /**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  let spImgList = [
    'https://cdn.shoplazza.com/89f3d8d490c84cddaad094c66f8b5cf8.png',
    'https://cdn.shoplazza.com/5405be7abb3efb29cda2ac86ce87df78.png',
    'https://cdn.shoplazza.com/f4d00eeb26d9ff9a64f2270b5cf00aa3.png',
    'https://cdn.shoplazza.com/e4a22d7ba8f159512a45759f10013af6.png',
    'https://cdn.shoplazza.com/5d2f23210b4391e9571e69498772dcdd.png',
    'https://cdn.shoplazza.com/061cee3554be6d062135503b99b2af1a.png',
    'https://cdn.shoplazza.com/b622904bbe6529eeb6359f7edf833e9f.png',
    'https://cdn.shoplazza.com/d4319816321e86aed0165a2b03deb6cb.png',
    'https://cdn.shoplazza.com/10ed1a735207d92bd393131c00da84f8.png',
    'https://cdn.shoplazza.com/8c33ea924292935321df3fbc3af5c322.png',
  ]

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      let scale = document.body.clientWidth / 1080
      console.log(document.body.clientWidth,"document.body.clientWidth")
      $('#root').css('zoom', scale)

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              let scale = document.body.clientWidth / 1080
              $('#root').css('zoom', scale)
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    preloadImages(spImgList)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        let _topHeight =
          $('.time-part').height() + $('.sp-header-top').height() - 12
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            _topHeight * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  let prods = window.product
  function getCur() {
    let color = $('#sp-number div.active').attr('data-val')
    console.log(color,"color");
    return prods.filter(item => item.option1 == color)[0]
  }
  function changePrice() {
    let num = $('#calcNumber').val()
    let price = Number(getCur().price * num / 100 ).toFixed(2)
    let compare = Number(getCur().compare_at_price * num / 100).toFixed(2)
    // if(num == 1){
    //   price = (getCur().price * num / 100).toFixed(2)
    // }else if(num == 2){
    //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
    // }else if(num == 3){
    //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
    // }else {
    //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
    // }
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $('#sp_price1').html(price)
    $('#sp_price2').html(compare)
    let off_font =
      100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
    $('.price-group .sp-row p span').html(off_font)
  }// 弹窗 start
   var main_id = "";
    $('.emitCheckout').click(function(){
      main_id = getCur().id
      // main_id = $(this).siblings('.select_span').find('span.on').data('id')
      // window.location.href = "/cart/" + id + ":1"
    })
  let popProduct = [
    {
      id:'6bca982d-e6df-466f-bf95-434e91b120d0',
      option1:'Buy 1',
      price:'9.99',
      compare_at_price:'14.99'
    },
    {
      id:'ab59b6ac-0eb3-4e3b-8936-053c51380275',
      option1:'Buy 2 Get 1 Free (3 PCS)',
      price:'19.99',
      compare_at_price:'44.97'
    },
    {
      id:'521e2678-b47f-4c63-9441-a9aa1c777ec3',
      option1:'Buy 3 Get 2 Free（5 PCS）',
      price:'29.99',
      compare_at_price:'74.95'
    },
    {
      id:'a5bc03a1-cdc2-4d46-a9dd-102fd766ead8',
      option1:'Buy 5 Get 5 Free（10 PCS）',
      price:'49.99',
      compare_at_price:'149.90'
    }
  ]

  function getPopProdId(){
    let selectVals = [];
    $(".overbuy-select input[type='radio']:checked").each(function(){
      selectVals.push($(this).val())
    })

    let cur = popProduct.filter(item => {
      let option1 = selectVals[0];
      let option2 = null;
      let option3 = null;
      if(selectVals[1]){
        option2 = selectVals[1];
      }
      if(selectVals[2]){
        option3 = selectVals[2];
      }

      
      return item.option1 == option1 
    })

 
    
    return cur[0];
  }

  $(".overbuy-select input[type='radio']").on('change',function(){
    let cur = getPopProdId();
    let _price = parseFloat(cur.price ).toFixed(2);
    let _compare_at_price = parseFloat(cur.compare_at_price ).toFixed(2);

    $('.overbuy_price span').eq(0).html('￡' + _price / 100);
    $('.overbuy_price span').eq(1).html('￡' + _compare_at_price / 100);
  })

  


  window.emitSubmit = function(_type){
     if(_type == 'all'){
      // var bundle_sku = data[$('input[name="overbuy1"]:checked').val()][$('input[name="overbuy2"]:checked').val()]
      let _id = getPopProdId()?.id;
      console.log(main_id,_id)
      var items = [{
        quantity: $('#calcNumber').val(),
        variant_id: main_id,
        note: '',
    },
        {
            quantity: 1,
            variant_id: _id,
            note: '',
        },
        ]
    // window.location.href = '/cart/' + getCur().id + ':' + num
        $.post('/api/checkout/order', {
        line_items: items,
        refer_info: { source: 'buy_now' }
    }, function (ret) {
        if (ret.state === 'success') {
            return (window.safeHref = '/checkout/' + ret.data.order_token + '?step=contact_information');
        } else {
            $.toast.show({
                content:
                    {
                        '30003': "Some items have been removed, please re-order",
                        'line_items_variant_withdraw': "Some items have been sold out, please re-order",
                        'line_items_variant_sold_out': "Some items are not in stock, please re-order"
                    }[ret.state] || ret.errors[0] || "Some items information has been updated, please re-order"
            });
        }
    });
      // window.location.href = '/cart/' + main_id + ':' + num + ',' +  _id + ':1';
    }else{
      // window.location.href = '/cart/' + main_id + ':' + num;
      var items = [{
        quantity: $('#calcNumber').val(),
        variant_id:  main_id,
        note: '',
    }]
    // window.location.href = '/cart/' + getCur().id + ':' + num
        $.post('/api/checkout/order', {
        line_items: items,
        refer_info: { source: 'buy_now' }
    }, function (ret) {
        if (ret.state === 'success') {
            return (window.safeHref = '/checkout/' + ret.data.order_token + '?step=contact_information');
        } else {
            $.toast.show({
                content:
                    {
                        '30003': "Some items have been removed, please re-order",
                        'line_items_variant_withdraw': "Some items have been sold out, please re-order",
                        'line_items_variant_sold_out': "Some items are not in stock, please re-order"
                    }[ret.state] || ret.errors[0] || "Some items information has been updated, please re-order"
            });
        }
    });
    }
  }


  // 弹窗 end
  $('.sp-btn-style').click(function () {
    let num = $('#calcNumber').val()
   window.location.href = '/cart/' + getCur().id + ':' + num
  })

  $('.sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    changePrice()
  })
  $('.sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    changePrice()
  })

  $(function () {
    $('.sp-option').click(function () {
      $(this).siblings().removeClass('active')
      $(this).addClass('active')
      // style选项

      let numberOptions = $('#sp-number .sp-option.active').index()
      let _index = numberOptions

      $('.product-part .sp-img-p')[0].src = spImgList[_index]
      changePrice()
    })

    // 购物车加购动效
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      $('.sp-header-top .sp-cart .num').show()
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })
    let initNum = 0
    $('.product-part .cart-btn').click(function () {
    //   var data = {
    //     id: getCur().id,
    //     quantity: $('#calcNumber').val(),
    //   }
    //   $.post(
    //     "/api/cart",
    //     { 
    //         product_id: getCur().product_id,
    //         variant_id: getCur().id,
    //         quantity: $('#calcNumber').val(),
    //     },
    //     function(res){
    //         $.get("/api/cart",function(res){
    //         $("#cardNum").html(res.cart.item_count);
    //         })
    //     }
    //     )
var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $("#cardNum").html(result.item_count);
            $("#cardNum").removeClass("sp-gray");
          });
        },
        dataType: "json",
      });
    //   $('#cardNum').removeClass('sp-gray')
      // handleAddToCart(initNum);

      var img = $('.product-part .sp-img-p')
      // var img = $(".product-part .swiper-slide-active .sp-img");

      var flyer = img[0].cloneNode(true)
      flyer.classList.add('sp_clone')

      $('.product-part').append(flyer)
      $('.sp_clone').css({
        width: img[0].width,
        height: img[0].height,
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })

      let finish = $('.sp-cart')
      $('.sp_clone').animate(
        {
          top:
            finish[0].offsetTop +
            finish.height() / 2 +
            $('.time-part').height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach()
            }
          )
        }
      )
    })
  })
})
